module.exports = __webpack_public_path__ + "img/jose.b4acfc50.png";